import Errored from '../Errored';
import GS from '../../grafsync/grafsync';
import PrimaryButton from '../PrimaryButton';
import { withStyles } from '@material-ui/core/styles';
import { Component, default as React } from 'react';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import TitledTextField from '../TitledTextField';

class SystemMessageReplay extends Component {

  constructor(props) {
    super(props);
    this.state = {
      message: "",
      valid: false
    };
  }

  handleChange = (event) => {
    const t = event.target;
    let valid;
    try {
      JSON.parse(t.value);
      valid = true;
    }
    catch (e) {
      valid = false;
    }
    this.setState({ [t.name]: t.value, completed: false, valid });
  };

  sendMessage = async () => {
    try {
      await GS.sendMessage(JSON.parse(this.state.message));
      this.setState({ message: "" });
    }
    catch (e) {
      console.log(e)// eslint-disable-line
      this.setState({
        isErrored: {
          message: "Cannot process message."
        }
      });
    }
  };

  render() {

    const { message, valid, isErrored } = this.state;

    if (isErrored) return <Errored data={isErrored} />;

    return (
      <TitledPanel height="full" dataTest="message-replay" fontSize="large" title="System Message Replay">
        <TitledTextField
          ariaLabel="Message"
          dataTest="message"
          name="message"
          title="Message (JSON)"
          autoFocus
          readOnly={false}
          text={message}
          multiline={true}
          placeholder="Paste message JSON here."
          maxLength={10000}
          onEnter={this.sendReplay}
          onChange={this.handleChange} />
        <div style={{ display: 'flex', margin: 10 }}>
          <div style={{ flex: 1 }}>
          </div>
          <div style={{ flex: '0 0' }}>
            <PrimaryButton disabled={message.trim().length === 0 || !valid} onClick={this.sendMessage}>Send</PrimaryButton>
          </div>
        </div>
      </TitledPanel>
    );
  }
}


export default withStyles(styles)(SystemMessageReplay);